// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-page {
  min-height: 100vh;
  position: relative;
  background: #0f172a;
  color: #e2e8f0;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;
  overflow-x: hidden;
}

.about-background {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 0;
}

.about-bg-gradient {
  position: absolute;
  inset: 0;
  background-image:
    radial-gradient(at 0% 0%, rgba(99, 102, 241, 0.18) 0px, transparent 55%),
    radial-gradient(at 50% 0%, rgba(168, 85, 247, 0.18) 0px, transparent 55%),
    radial-gradient(at 100% 100%, rgba(59, 130, 246, 0.18) 0px, transparent 55%);
}

.about-bg-grid {
  position: absolute;
  inset: 0;
  background-image:
    radial-gradient(circle at 20% 50%, rgba(255, 255, 255, 0.06) 1px, transparent 1px),
    radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.06) 1px, transparent 1px),
    radial-gradient(circle at 40% 80%, rgba(255, 255, 255, 0.06) 1px, transparent 1px);
  background-size: 90px 90px, 130px 130px, 110px 110px;
  animation: aboutFloat 22s ease-in-out infinite;
}

@keyframes aboutFloat {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  25% { transform: translate(1.5%, 1%) rotate(0.5deg); }
  50% { transform: translate(-1%, 1.5%) rotate(-0.5deg); }
  75% { transform: translate(1%, -1%) rotate(0.3deg); }
}

.about-container {
  position: relative;
  z-index: 1;
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.about-header {
  padding: 64px 0 32px;
  text-align: center;
}

.about-logo {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  margin-bottom: 16px;
}

.about-logo-icon {
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  color: white;
  font-size: 18px;
  box-shadow: 0 10px 25px rgba(99, 102, 241, 0.35);
}

.about-logo-text {
  font-size: 26px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #f8fafc;
}

.about-tagline {
  color: #94a3b8;
  font-size: 16px;
  max-width: 640px;
  margin: 0 auto;
  line-height: 1.6;
}

.about-content {
  flex: 1 1;
  padding: 24px 0 48px;
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.about-section h2 {
  margin: 0 0 14px;
  font-size: 22px;
  font-weight: 700;
  color: #f8fafc;
  letter-spacing: -0.01em;
}

.about-section p {
  margin: 0;
  color: #cbd5e1;
  font-size: 15px;
  line-height: 1.7;
}

.about-values {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 18px;
  margin-top: 18px;
}

.about-value-card {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 18px;
  padding: 22px;
  backdrop-filter: blur(10px);
  transition: transform 0.2s ease, border-color 0.2s ease, background 0.2s ease;
}

.about-value-card:hover {
  transform: translateY(-3px);
  border-color: rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.06);
}

.about-value-card h3 {
  margin: 0 0 8px;
  font-size: 16px;
  font-weight: 600;
  color: #f1f5f9;
}

.about-value-card p {
  margin: 0;
  color: #94a3b8;
  font-size: 14px;
  line-height: 1.55;
}

.about-cta {
  text-align: center;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  padding: 30px 24px;
  backdrop-filter: blur(10px);
}

.about-cta h2 {
  margin-bottom: 10px;
}

.about-cta p {
  margin-bottom: 20px;
}

.about-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
}

.about-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 20px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.01em;
  text-decoration: none;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.about-btn-primary {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  color: white;
  box-shadow: 0 6px 20px rgba(99, 102, 241, 0.4);
}

.about-btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 28px rgba(99, 102, 241, 0.55);
}

.about-btn-secondary {
  background: rgba(255, 255, 255, 0.06);
  color: #e2e8f0;
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.about-btn-secondary:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-2px);
}

.about-footer {
  padding: 22px 0 28px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  color: #64748b;
  font-size: 13px;
}

.about-footer-links {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.about-footer-links a {
  color: #94a3b8;
  text-decoration: none;
  font-size: 13px;
  transition: color 0.2s ease;
}

.about-footer-links a:hover {
  color: #e2e8f0;
}

@media (max-width: 768px) {
  .about-header {
    padding: 48px 0 24px;
  }

  .about-content {
    gap: 28px;
    padding: 16px 0 36px;
  }

  .about-values {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .about-logo-text {
    font-size: 22px;
  }

  .about-tagline {
    font-size: 14px;
  }

  .about-section h2 {
    font-size: 20px;
  }

  .about-footer {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/About.css"],"names":[],"mappings":"AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,uGAAuG;EACvG,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;;gFAG8E;AAChF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;;sFAGoF;EACpF,oDAAoD;EACpD,8CAA8C;AAChD;;AAEA;EACE,WAAW,uCAAuC,EAAE;EACpD,MAAM,6CAA6C,EAAE;EACrD,MAAM,+CAA+C,EAAE;EACvD,MAAM,4CAA4C,EAAE;AACtD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,qDAAqD;EACrD,YAAY;EACZ,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,6EAA6E;AAC/E;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,+CAA+C;EAC/C,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');\n\n.about-page {\n  min-height: 100vh;\n  position: relative;\n  background: #0f172a;\n  color: #e2e8f0;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;\n  overflow-x: hidden;\n}\n\n.about-background {\n  position: fixed;\n  inset: 0;\n  pointer-events: none;\n  z-index: 0;\n}\n\n.about-bg-gradient {\n  position: absolute;\n  inset: 0;\n  background-image:\n    radial-gradient(at 0% 0%, rgba(99, 102, 241, 0.18) 0px, transparent 55%),\n    radial-gradient(at 50% 0%, rgba(168, 85, 247, 0.18) 0px, transparent 55%),\n    radial-gradient(at 100% 100%, rgba(59, 130, 246, 0.18) 0px, transparent 55%);\n}\n\n.about-bg-grid {\n  position: absolute;\n  inset: 0;\n  background-image:\n    radial-gradient(circle at 20% 50%, rgba(255, 255, 255, 0.06) 1px, transparent 1px),\n    radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.06) 1px, transparent 1px),\n    radial-gradient(circle at 40% 80%, rgba(255, 255, 255, 0.06) 1px, transparent 1px);\n  background-size: 90px 90px, 130px 130px, 110px 110px;\n  animation: aboutFloat 22s ease-in-out infinite;\n}\n\n@keyframes aboutFloat {\n  0%, 100% { transform: translate(0, 0) rotate(0deg); }\n  25% { transform: translate(1.5%, 1%) rotate(0.5deg); }\n  50% { transform: translate(-1%, 1.5%) rotate(-0.5deg); }\n  75% { transform: translate(1%, -1%) rotate(0.3deg); }\n}\n\n.about-container {\n  position: relative;\n  z-index: 1;\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 0 20px;\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n.about-header {\n  padding: 64px 0 32px;\n  text-align: center;\n}\n\n.about-logo {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  text-decoration: none;\n  margin-bottom: 16px;\n}\n\n.about-logo-icon {\n  width: 40px;\n  height: 40px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 12px;\n  background: linear-gradient(135deg, #6366f1, #8b5cf6);\n  color: white;\n  font-size: 18px;\n  box-shadow: 0 10px 25px rgba(99, 102, 241, 0.35);\n}\n\n.about-logo-text {\n  font-size: 26px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: #f8fafc;\n}\n\n.about-tagline {\n  color: #94a3b8;\n  font-size: 16px;\n  max-width: 640px;\n  margin: 0 auto;\n  line-height: 1.6;\n}\n\n.about-content {\n  flex: 1;\n  padding: 24px 0 48px;\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n}\n\n.about-section h2 {\n  margin: 0 0 14px;\n  font-size: 22px;\n  font-weight: 700;\n  color: #f8fafc;\n  letter-spacing: -0.01em;\n}\n\n.about-section p {\n  margin: 0;\n  color: #cbd5e1;\n  font-size: 15px;\n  line-height: 1.7;\n}\n\n.about-values {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 18px;\n  margin-top: 18px;\n}\n\n.about-value-card {\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 18px;\n  padding: 22px;\n  backdrop-filter: blur(10px);\n  transition: transform 0.2s ease, border-color 0.2s ease, background 0.2s ease;\n}\n\n.about-value-card:hover {\n  transform: translateY(-3px);\n  border-color: rgba(255, 255, 255, 0.18);\n  background: rgba(255, 255, 255, 0.06);\n}\n\n.about-value-card h3 {\n  margin: 0 0 8px;\n  font-size: 16px;\n  font-weight: 600;\n  color: #f1f5f9;\n}\n\n.about-value-card p {\n  margin: 0;\n  color: #94a3b8;\n  font-size: 14px;\n  line-height: 1.55;\n}\n\n.about-cta {\n  text-align: center;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 20px;\n  padding: 30px 24px;\n  backdrop-filter: blur(10px);\n}\n\n.about-cta h2 {\n  margin-bottom: 10px;\n}\n\n.about-cta p {\n  margin-bottom: 20px;\n}\n\n.about-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  justify-content: center;\n}\n\n.about-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 12px 20px;\n  border-radius: 12px;\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  text-decoration: none;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.about-btn-primary {\n  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);\n  color: white;\n  box-shadow: 0 6px 20px rgba(99, 102, 241, 0.4);\n}\n\n.about-btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 28px rgba(99, 102, 241, 0.55);\n}\n\n.about-btn-secondary {\n  background: rgba(255, 255, 255, 0.06);\n  color: #e2e8f0;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n}\n\n.about-btn-secondary:hover {\n  background: rgba(255, 255, 255, 0.1);\n  transform: translateY(-2px);\n}\n\n.about-footer {\n  padding: 22px 0 28px;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  align-items: center;\n  justify-content: space-between;\n  color: #64748b;\n  font-size: 13px;\n}\n\n.about-footer-links {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.about-footer-links a {\n  color: #94a3b8;\n  text-decoration: none;\n  font-size: 13px;\n  transition: color 0.2s ease;\n}\n\n.about-footer-links a:hover {\n  color: #e2e8f0;\n}\n\n@media (max-width: 768px) {\n  .about-header {\n    padding: 48px 0 24px;\n  }\n\n  .about-content {\n    gap: 28px;\n    padding: 16px 0 36px;\n  }\n\n  .about-values {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 480px) {\n  .about-logo-text {\n    font-size: 22px;\n  }\n\n  .about-tagline {\n    font-size: 14px;\n  }\n\n  .about-section h2 {\n    font-size: 20px;\n  }\n\n  .about-footer {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
